var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 18,
    viewBox: "0 0 10 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 9.00015C10 9.32263 9.87999 9.64518 9.64052 9.89113L2.0972 17.6307C1.61736 18.1231 0.839382 18.1231 0.359735 17.6307C-0.119912 17.1386 -0.119912 16.3405 0.359735 15.8481L7.03437 9.00015L0.360201 2.15188C-0.119446 1.65974 -0.119446 0.861536 0.360201 0.369434C0.839848 -0.123144 1.61759 -0.123144 2.09743 0.369434L9.64079 8.10892C9.88022 8.355 10 8.67755 10 9.00015Z",
    fill: "#151B26"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default ForwardRef;